import { useSelector } from "react-redux";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";
import {
    selectNumberOfSignalsFromSource,
    selectSignalsById,
} from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

import LoaderGradient from "../../shared/Loader/LoaderGradient";
import SignalsManagementButton from "../SignalsManagementButton/SignalsManagementButton";
import SignalsPromoBanner from "../SignalsPromoBanner/SignalsPromoBanner";

type SignalEventListProps = {
    title: string;
    isLoading?: boolean;
};

const SignalEventListHeader = ({ title, isLoading }: SignalEventListProps) => {
    const numberOfAllSignals = useSelector(selectNumberOfSignalsFromSource);
    const signalsGroupedById = useSelector(selectSignalsById);
    const areAllSignalsDefault = signalsService.areAllSignalsDefault({
        numberOfAllSignals,
        signalsGroupedById,
    });

    return (
        <Box
            data-automation="content-section-header"
            borderRadius="6px 6px 0 0"
            borderBottom="1px solid #e8e8e8"
            background={rgba(colorsPalettes.carbon["25"], 0.4)}
        >
            <Box padding="23px 32px 23px 31px">
                <Flex
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Text
                        fontVariant="h5"
                        color={colorsPalettes.carbon["500"]}
                    >
                        {title}
                    </Text>
                    {isLoading ? (
                        <LoaderGradient
                            width={182}
                            height={36}
                        />
                    ) : !areAllSignalsDefault && numberOfAllSignals !== 0 ? (
                        <SignalsManagementButton
                            type="flat"
                            onManageClick={() =>
                                companyAnalysisTrackingService.signalEvents.trackClickOnManageSignals(
                                    "manage signals button",
                                )
                            }
                        />
                    ) : null}
                </Flex>

                {areAllSignalsDefault ? <SignalsPromoBanner /> : null}
            </Box>
        </Box>
    );
};

export default SignalEventListHeader;
